import React, { ReactElement } from "react";
import { WidgetProps } from "@rjsf/utils";
import Textarea from "@amzn/awsui-components-react-v3/polaris/textarea";
import { placeholder } from "../utils";

export default function TextareaWidget(props: WidgetProps): ReactElement {
  return (
    <Textarea
      id={props.id}
      value={props.value}
      placeholder={placeholder(props)}
      ariaRequired={props.required}
      disabled={props.disabled}
      readOnly={props.readonly}
      autoFocus={props.autofocus}
      rows={props.options.rows as any}
      onBlur={() => props.onBlur(props.id, null)}
      onFocus={() => props.onFocus(props.id, null)}
      onChange={e => props.onChange(e.detail.value)}
    />
  );
}
